<template>
  <section class="[ flex flex-col max-w-7xl mx-auto gap-3 w-full h-full ]">
    <router-view />
  </section>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useTeamStore } from "@/store/admin/team.ts";

definePage({
  meta: {
    title: "Team management",
    icon: "user-group",
    showInBreadcrumb: true,
    scope: "Team.Read",
  },
  redirect: "/teams/list",
});

const teamStore = useTeamStore();

onMounted(async () => {
  await teamStore.fetchTeams();
});
</script>
